// All PlayByPlay event types live in common/types/gameSim.ts so UI's
// processLiveGameEvents renderer can reference them without crossing
// into server/. This file keeps the runtime: scoring-event detection +
// the BasketballPlayByPlayLogger class.

import type {
	PlayByPlayEventInput,
	PlayByPlayEventInputScore,
	PlayByPlayEventOutput,
} from "../../../../common/types/gameSim.ts";
import { PlayByPlayLoggerBase } from "../GameSim/PlayByPlayLoggerBase.ts";

// Re-export the event types so existing server-internal imports of
// `BlockType`, `FgaType`, `FgMakeType`, etc. from this module keep working.
export type {
	BlockType,
	FgaType,
	FgMissType,
	FgMakeNormalType,
	FgMakeType,
	PlayByPlayEventInput,
	PlayByPlayEventInputScore,
	PlayByPlayEventOutput,
} from "../../../../common/types/gameSim.ts";

const scoringTypes: Set<PlayByPlayEventInput["type"]> = new Set([
	"fgAtRim",
	"fgAtRimAndOne",
	"fgLowPost",
	"fgLowPostAndOne",
	"fgMidRange",
	"fgMidRangeAndOne",
	"ft",
	"tp",
	"tpAndOne",
] satisfies PlayByPlayEventInputScore["type"][]);

const isScoringPlay = (
	event: PlayByPlayEventInput,
): event is PlayByPlayEventInputScore => {
	return scoringTypes.has(event.type);
};

class BasketballPlayByPlayLogger extends PlayByPlayLoggerBase<PlayByPlayEventOutput> {
	private period = 1;
	constructor(active: boolean) {
		super(active);
	}

	logEvent(event: PlayByPlayEventInput) {
		if (event.type === "period" || event.type === "overtime") {
			this.period = event.period;
		}

		if (isScoringPlay(event)) {
			const event2 = {
				...event,
				period: this.period,
			};
			if (this.active) {
				this.playByPlay.push(event2);
			}
		} else {
			if (this.active) {
				this.playByPlay.push(event);
			}
		}
	}
}

export default BasketballPlayByPlayLogger;
